module.exports = __webpack_public_path__ + "static/media/stepper-configure.06293cdd.svg";